import { render } from "./CardPlans.vue?vue&type=template&id=bf04aff6"
import script from "./CardPlans.vue?vue&type=script&lang=js"
export * from "./CardPlans.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__